import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/navigation';

interface Props {
    title?: string;
    description?: string;
    action?: ReactNode;
}

export const NoPermission = ({
    title = 'Bạn không có quyền truy cập',
    description = 'Vui lòng liên hệ quản trị viên để được cấp quyền.',
    action,
}: Props) => {
    const router = useRouter();

    return (
        <Box
            display='flex'
            flexDirection='column'
            justifyContent='center'
            alignItems='center'
            textAlign='center'
            p={4}
            minHeight='300px'
        >
            <Typography variant='h5' fontWeight='bold' mb={2}>
                {title}
            </Typography>
            <Typography variant='body1' color='textSecondary' mb={4}>
                {description}
            </Typography>
            {action ? (
                action
            ) : (
                <Button variant='contained' onClick={() => router.back()}>
                    Quay lại
                </Button>
            )}
        </Box>
    );
};
